import { Card, Col, Row, Button} from 'antd';
import './../assets/css/report.css'
import React, { useEffect, useState } from 'react'
import { connect, useSelector } from 'react-redux'
import { axiosConfig, ordinal_suffix_of, SERVER_PATH, valdateJson } from '../actions/common';
import PageHeader from './PageHeader';
import ReactStars from "react-rating-stars-component"
import {  ButtonGroup, Container } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
function toSentenceCase(str){
    return str.charAt(0).toUpperCase() + str.slice(1);;
}

const Page = (props) => {

    const nav = useNavigate()

    const [studentcomments, setstudentcomments] = useState([])
    
    const { 
        user, 
        report, 
        cas, 
        bas,  
        attendance,
        punctuality,
        subject, 
        studentid, 
        class_grades,
        rank_student, 
        rank_subject,
        rank_subjects,
        rank_students,
        student_pop, 
        data, 
        cahead,
        behavior 
    } = props

    useEffect(() => {
        let params = {
            data:JSON.stringify(
            {
                    'studentid':studentid,
                    'reportid':store_data?.data?.id || null
                }),
                cat:'selected',
                table:'studentcomments',
                narration:'get subjects'
            }

        axios.get(SERVER_PATH, {params}, axiosConfig)
        .then(res=>{
            return res.data
        })
        .then(res=>{
            setstudentcomments(res)  
        })
        .catch(err=>{
            console.log(err)
        })
     
    }, [studentid, store_data?.data?.id || null ])

  
   
    let ca_sum = {}
    let ca_sums = {}
    const store_data = localStorage.getItem('selectedresult') !== 'undefined' && localStorage.getItem('selectedresult') !== null && localStorage.getItem('selectedresult') !== undefined ? JSON.parse(localStorage.getItem('selectedresult')) : {}
    const reportinfo = store_data.data;
    const schoolinfo = store_data.schooldata;
    const claszinfo = store_data.classdata;
    const [fontz, setfontz] = useState(14)



    const {setting:report_settings, generalcomment} = reportinfo || {}
    let report_object = valdateJson(report_settings) ? JSON.parse(report_settings) : []


    const class_position = report_object.includes('class_position') ? false : true;
    const score_column =  report_object.includes('score_column') ? false : true;
    const total_column =  report_object.includes('total_column') ? false : true;
    const grade_column = report_object.includes('grade_column') ? false : true;
    const grade_inter =  report_object.includes('grade_inter') ? true : false;
    const subject_maximum = report_object.includes('subject_maximum') ? false : true;
    const subject_minimum = report_object.includes('subject_minimum') ? false : true;
    const subject_ranking = report_object.includes('subject_ranking') ? false : true;
    const subject_average = report_object.includes('subject_average') ? false : true;
    const summary_row = report_object.includes('summary_row') ? false : true;
    const table_key = report_object.includes('table_row') ? false : true;
    const summary_card = report_object.includes('summary_card') ? false : true;
    const behaviors = report_object.includes('behavior') ? false : true;
    const comment = report_object.includes('comment') ? false : true; 
    const parent_comment = report_object.includes('parent_comment') ? false : true; 
    const class_attendance = report_object.includes('class_attendance') ? false : true; 
    
    const bgc = ['black', 'white']
  
    const rank = (sumz, topscore)=>{
        if(sumz !== undefined && topscore !== undefined)
        {
            let score = sumz.reduce((a, b)=>parseFloat(a) + parseFloat(b), 0);
            let tscore = Object.values(topscore).reduce((a,b)=>parseFloat(a) + parseFloat(b), 0);
            
            let mscore = (parseFloat(score)/tscore) * 100 
            return Number(mscore).toFixed(1)
        }
    }
    const sum1001 = (sumz, topscore)=>{
        if(sumz !== undefined && topscore !== undefined)
        {
            let score = sumz.reduce((a, b)=>parseFloat(a) + parseFloat(b), 0);
            let tscore = Object.values(topscore).filter(rw=>rw > 0).reduce((a,b)=>parseFloat(a) + parseFloat(b), 0);
            let mscore = (parseFloat(score)/tscore) * 100 
            return Number(mscore).toFixed(1)
        }
    }
    const avg = (sumz)=>{
        if(sumz !== undefined && Array.isArray(sumz) && sumz.length > 0)
        {
            let sums = sumz.reduce((a, b)=>parseFloat(a) + parseFloat(b), 0);
            return Number(sums/sumz.length).toFixed(1)}
    }
    const min = (sumz)=>{if(sumz !== undefined && Array.isArray(sumz)){return Math.min(...sumz)}}
    const max = (sumz)=>{if(sumz !== undefined && Array.isArray(sumz)){return Math.max(...sumz)}}

    const format = (f, topscore) =>{
        if(parseFloat(f)> 0 && topscore !== undefined)
        {
            let score = f;
            let tscore = Object.values(topscore).reduce((a,b)=>parseFloat(a) + parseFloat(b), 0);
            let mscore = (parseFloat(score)/tscore) * 100
            return Number(mscore).toFixed(1)
        }
    }
    const get_data = (data, id, col, co) =>{
        //console.log(data, id, col, co)
            if(Array.isArray(data)){
                let d = data.filter(rw=>rw[col] == id);
                if(Array.isArray(d) && d.length == 1 ){
                    let e = d[0]
                    return e[co] > 0 ? Number(e[co]).toFixed(0) : 0
                }else{
                    return '-'
                }
            }else{
                return '-'
            }
            
    }
    const get_datass = (data, id, col, co) =>{
        let d = data.filter(rw=>parseInt(rw.studentid) === parseInt(id));
        if(Array.isArray(d) && d.length === 1 ){
            let e = d[0]
            return e[co] > 0 ? Number(e[co]).toFixed(0) : 0
        }
        return '-'
    }  
    const get_datas = (data, id, col, co) =>{
        
        let d = data.filter(rw=>parseInt(rw[col]) === parseInt(id));
        if(Array.isArray(d) && d.length === 1 )
        {
            
            let e = d[0]
            return e[co] > 0 ? Number(e[co]).toFixed(0) : 0
        }
        return '-'
    }  
    const grading1 = (scor, gra, topscore) =>{
        if(scor!== undefined && gra !== undefined)
        {
            
            let score = scor.reduce((a,b)=>parseFloat(a) + parseFloat(b), 0);
            let tscore = Object.values(topscore).filter(rw=>rw > 0).reduce((a,b)=>parseFloat(a) + parseFloat(b), 0);
            let mscore = (parseFloat(score)/tscore) * 100
            let re = gra.filter(ele=>parseInt(mscore) > parseInt(ele.minscore) && parseInt(mscore) <= parseInt(ele.maxscore))
            return re !==undefined && Array.isArray(re) && re.length > 0  ? re[0].gradeabbrv:'NONE';
        }
    }
    const grading2 = (scor, gra, topscore) =>{
        if(scor!== undefined && gra !== undefined)
        {
            
            let score = scor.reduce((a,b)=>parseFloat(a) + parseFloat(b), 0);
            let tscore = Object.values(topscore).filter(rw=>rw > 0).reduce((a,b)=>parseFloat(a) + parseFloat(b), 0);
            let mscore = (parseFloat(score)/tscore) * 100
            let re = gra.filter(ele=>parseInt(mscore) > parseInt(ele.minscore) && parseInt(mscore) <= parseInt(ele.maxscore))
            return re !==undefined && Array.isArray(re) && re.length > 0  ? re[0].gradename:'NONE';
        }
    }
    const gradingf = (scor, gra) =>{
        if(scor!== undefined && gra !== undefined)
        {        
            let score = scor;
            let re = gra.filter(ele=>parseInt(score) > parseInt(ele.minscore) && parseInt(score) <= parseInt(ele.maxscore))
            return re !==undefined && Array.isArray(re) && re.length > 0  ? re[0].gradeabbrv:'NONE';
        }
    }
    const gradingf1 = (scor, gra) =>{
        if(scor!== undefined && gra !== undefined)
        {        
            let score = scor;
            let re = gra.filter(ele=>parseInt(score) > parseInt(ele.minscore) && parseInt(score) <= parseInt(ele.maxscore))
            return re !== undefined && Array.isArray(re) && re.length > 0  ? re[0].gradename :'NONE';
        }
    }
    const gradingcomment = (scor, gra) =>{
        
        if(scor!== undefined && gra !== undefined)
        {   
            let score = scor;
            let re = gra.filter(ele=>parseInt(score) > parseInt(ele.minscore) && parseInt(score) <= parseInt(ele.maxscore))
            return re !==undefined && Array.isArray(re) && re.length > 0  ? re[0].comment:'NONE';
        }
    }

    
    let num_subjects = 0
    let numbering = 0
    let subject_result ={}
    let s_result = Object.keys(subject).sort((a,b)=>subject[a] > subject[b])
    s_result.forEach(key => { subject_result[key] = subject[key]; })
    let acct = Object.keys(subject_result).map((row, ind)=>{
        if(data && Array.isArray(Object.keys(data)) && data.hasOwnProperty(row)  && data[row] !== undefined )
          {
          let subs= [];
          let adds = [];
          let ca_sums = {};
          num_subjects = num_subjects + 1;
          let d = subject_result !== undefined && subject_result.hasOwnProperty(row) && subject_result[row] !== null ? subject_result[row].split(":::") : [];
          return <tr key={`${row}`}  style={{fontSize: fontz+"px"}} >
          <td className="text-center m-0 p-0">
           {numbering = numbering + 1}
          </td>
          <td className="text-left m-0 p-0">
          <div style={{fontSize: fontz+"px", textTransform:'capitalize'}} className="m-0 p-0">{d[0]}</div>
          </td>
          {       
              Object.keys(cas).map((prop, inds)=>{
                let sumrow = [];
                let totrow = [];
                if(ca_sum.hasOwnProperty(prop)){}
                else{ca_sum[prop] = []}
                if(ca_sums.hasOwnProperty(prop)){}
                else{ca_sums[prop] = []}
            
                if(data && Array.isArray(Object.keys(data)) && data.hasOwnProperty(row) && data[row].hasOwnProperty(prop))
                {
                  //SET CA SUM
                  let sh = data[row][prop];
                  if(sh > 0)
                  { 
                     ca_sum[prop].push(sh) 
                     ca_sums[prop].push(cahead[prop])
                  }
                  let shmax = cahead[prop];
                  sumrow.push(sh)
                  totrow.push(shmax)
                  subs.push(sh)
                  adds.push(shmax)
                  return <td key={`${inds}_a`} className='text-center m-0 p-0' style={{fontSize: fontz+"px"}} >{parseFloat(sh) > 0 ? Number(sh).toFixed(1) : '-'}</td>
                }else
                {
                  return <td key={`${inds}_b`} className='text-center m-0 p-0' >-</td>
                }   
             })  
          }
          
          {/* <th className='text-center m-0 p-0' style={{backgroundColor:bgc[0], color:bgc[1], fontSize: fontz+"px"}}>{sum1001(subs, ca_sums)}</th>
          <td className='text-center m-0 p-0' style={{fontSize: fontz+"px"}}>{grading1(subs, class_grades, ca_sums)}</td>
          <td className='text-center m-0 p-0' style={{fontSize: fontz+"px"}}>{get_data(rank_subject, row, 'subjectid', 'avg')}</td>
          <td className='text-center m-0 p-0' style={{fontSize: fontz+"px"}}>{get_data(rank_subject, row, 'subjectid', 'max')}</td>
          <td className='text-center m-0 p-0' style={{fontSize: fontz+"px"}}>{get_data(rank_subject, row, 'subjectid', 'min')}</td>
          <td className='text-right m-0 p-0'  style={{fontSize: fontz+"px"}}>{` ${ordinal_suffix_of(get_datas(rank_students[studentid], row, 'subjectid', 'rank'))} of ${get_data(rank_subject, row, 'subjectid', 'pop')}`}</td>
      */}
        { total_column ? <th className='text-center m-0 p-0' style={{backgroundColor:bgc[0], color:bgc[1], fontSize: fontz+"px"}}>{sum1001(subs, ca_sums)}</th>:null}
        { grade_column ? <td className='text-center m-0 p-0' style={{fontSize: fontz+"px"}}>{grading1(subs, class_grades, ca_sums)}</td>:null}
        { grade_inter ? <td className='text-left m-0 px-1' style={{fontSize: fontz+"px", marginLeft:'1px'}}>{grading2(subs, class_grades, ca_sums)}</td>:null}
        { subject_average ? <td className='text-center m-0 p-0' style={{fontSize: fontz+"px"}}>{get_data(rank_subject, row, 'subjectid', 'avg')}</td>:null}
        { subject_minimum ? <td className='text-center m-0 p-0' style={{fontSize: fontz+"px"}}>{get_data(rank_subject, row, 'subjectid', 'max')}</td>:null}
        { subject_minimum ? <td className='text-center m-0 p-0' style={{fontSize: fontz+"px"}}>{get_data(rank_subject, row, 'subjectid', 'min')}</td>:null}
        { subject_ranking ?   <td className='text-right m-0 p-0'  style={{fontSize: fontz+"px"}}>{` ${ordinal_suffix_of(get_datas(rank_students[studentid], row, 'subjectid', 'rank'))} of ${get_data(rank_subject, row, 'subjectid', 'pop')}`}</td>:null}
     
      </tr>
        }
    })
    let s_sum = []
    let s_avg = []
    let s_min = []
    let s_max = []
    
    Object.keys(subject).forEach(row =>{
        if(data && Array.isArray(Object.keys(data)) && data.hasOwnProperty(row)  && data[row] !== undefined )
        {
              let subs= [];
              let adds = [];
              let ca_sums =[]
              Object.keys(cas).forEach(prop=>{
                    let sumrow = [];
                    let totrow = [];
                    if(ca_sums.hasOwnProperty(prop)){}
                    else{ca_sums[prop] = []}
                   
                    if(data && Array.isArray(Object.keys(data)) && data.hasOwnProperty(row) && data[row].hasOwnProperty(prop))
                    {
                      //SET CA SUM
                      let sh = data[row][prop];
                      if(sh > -1)
                      { 
                         ca_sum[prop].push(sh) 
                         ca_sums[prop].push(cahead[prop])
                      }
                      let shmax = 20;//ca_score[prop];
                      sumrow.push(sh)
                      totrow.push(shmax)
                      subs.push(sh)
                      adds.push(shmax)
                    }  
              })
              ordinal_suffix_of(get_data(rank_subjects[row], studentid, 'subjectid', 'rank'))
              s_sum.push(sum1001(subs, ca_sums))
              s_avg.push(get_data(rank_subject, row, 'subjectid', 'avg'))
              s_max.push(get_data(rank_subject, row, 'subjectid', 'max'))
              s_min.push(get_data(rank_subject, row, 'subjectid', 'min'))
        }         
    })

    let position_cm = {} //} decision_maker(deci, classid, s_store, candidates_avg)
   
    let position_cm_arr = {}
    Object.keys(position_cm).map((prop, ins)=>{
            let {positive, negative, state, subjects, avg} = position_cm[prop] || ''
           // console.log(state, subjects, avg)
            let c1 = !state ? positive : negative 
            let c2 = state && subjects.length > 0  ? `your performance in ${subjects.join(', ')} ${subjects.length == 1 ? 'is' : 'are'} below the stipulated cutoff mark`: null
            let c3 = state &&  avg.length > 0 && avg.includes(1) ? `your average is below the minimum score required`: null
            let c4 = state &&  avg.length > 0 && avg.includes(2) ? `you did not pass the required minimum number of subjects`: null
            let res = [c2, c3, c4, c1]
            position_cm_arr[prop] = res.filter(rw=>rw != null)
    })
    
    let theadm = Object.keys(cas).map((prp, ind)=>{
        let d = cas !== undefined && cas.hasOwnProperty(prp) && cas[prp] !== null ? cas[prp].split(":::") : ';';
        return<th key={ind} className="text-center" width="60px">{d[1]}<br/>({d[2] ?? ''})</th>
    });
    let tfootm = Object.keys(cas).map((prp, ind)=>{
        let d = avg(ca_sum[prp])
        return<th key={ind} className="text-center m-0 p-0 text-center align-self-center" width="60px">{d}</th>
    });

    
    const {
        surname,
        firstname,
        middlename,
        admission_no,
        admit,
        gender,
        abbrv,
        photo
    } = user || 'None';

    let name1 = gender !== undefined && gender.toLowerCase() == 'male' ? 'his' : 'her'
    let name2 = gender !== undefined && gender.toLowerCase() == 'male' ? "he" : 'she'
    let name3 = gender !== undefined && gender.toLowerCase() == 'male' ? 'him': 'her'
    
    
    const {name:schoolname, staffname, officename, phone1 } = schoolinfo || ''
    const {name:claszname} = claszinfo || ''
    const {title:reportname, id:reportid} = reportinfo || ''
    let fullname = surname+" "+firstname+" "+middlename

    let pos = get_datass(rank_student, studentid, 'studentid', 'rank')
    let popu = rank_student.length
    let pos_pers =  pos > 0 && popu > 0 ? Number((pos/popu) * 100).toFixed(0) : 0
    let pos_messg = '' 
     if(pos_pers > 0 && pos_pers < 5.1){pos_messg = 'You are one of the top five percent in your class';}
     if(pos_pers > 5 && pos_pers < 10.1){pos_messg = 'You are one of the top ten percent in your class';}
     if(pos_pers > 10 && pos_pers < 25.1){pos_messg = 'You are one of the top twenty-five percent in your class';}
     if(pos_pers > 25 && pos_pers < 50.1){pos_messg = 'You are one of the top fifty percent in your class';}


    const move = () =>{
        nav(`./report/${reportid}/1`)
    }
    const movecbt = () =>{
        nav(`./reportcbt`)
    }
    console.log(studentcomments)
    return (
<>
<Row gap="small" wrap="wrap" className='no-print'>
    <Col style={{margin:'2px', padding:'5px'}}>
    <Button style={{padding:'3px', margin:'5px'}} onClick={()=>nav(-1)} type="info" shape="circle" className='mfe-2' icon={<i className="fa fa-backward"></i>} size='middle' />
    <Button style={{padding:'3px', margin:'5px'}}  onClick={()=>window.print()} type="primary" shape="circle" icon={<i className="fa fa-print"></i>} size='middle' />
    <Button style={{padding:'3px', margin:'5px'}}  onClick={()=>move(-1)} type="primary"  icon={<i className="fa fa-file"></i>} size='middle'>
     {" "}View Details
    </Button>
    <Button style={{padding:'3px', margin:'5px'}}  onClick={()=>movecbt()} type="primary"  icon={<i className="fa fa-computer"></i>} size='middle'>
     {" "}CBT
    </Button>
    </Col>
    
</Row>
<div className="report container" id="maincont1" style={{margin:'auto', padding:'auto', backgroundColor:'#fff',}} >
<div className="printpage" style={{marginLeft:'auto', marginRight:'auto'}}>
    <div className="A4" 
    style={{
            overflow:'hidden',
            position: 'relative',
            backgroundColor:'#fff',
            padding:'10px'
        }}>
    <Col>
        
        <span className="d-none d-print-block text-left p-10" >
        <PageHeader />
        <Row>
            <Col span={24} className="reportname">
                <h4>{reportname}</h4>
            </Col>
        </Row>
        <Row>
            <Col span={24} className="schoolname">
                <h4>{schoolname}</h4>
            </Col>
        </Row>
        </span>
        <Row>
            <Col span={20}>
            <Row span={24}>
                <Col span={10} className='label_title' style={{textTransform:'capitalize'}}>Fullname </Col>
                <Col span={14} className='text_title' style={{textTransform:'capitalize', fontWeight:'bold', fontSize:fontz+"px"}}>{fullname}</Col>
            </Row>
            <Row span={24}>
                <Col span={10} className='label_title'>Matriculation Number</Col>
                <Col span={14} className='text_title' style={{textTransform:'capitalize', fontWeight:'bold'}}>{abbrv}{admit}/{admission_no}</Col>
            </Row>
            <Row span={24}>
                <Col span={10} className='label_title'>Gender</Col>
                <Col span={14} className='text_title' style={{textTransform:'capitalize', fontWeight:'bold'}}>{gender}</Col>
            </Row>
            <Row span={24}>
                <Col span={10} className='label_title'>Class</Col>
                <Col span={14} className='text_title' style={{textTransform:'capitalize', fontWeight:'bold'}}>{claszname}</Col>
            </Row>
            <Row span={24}>
                <Col span={10} className='label_title'>Dated</Col>
                <Col span={14} className='text_title' style={{textTransform:'capitalize', fontWeight:'bold'}}>{new Date().toDateString()}</Col>
            </Row>
            {class_position ?
            <Row span={24}>
            <Col span={10} className='label_title'>Position in Class</Col>
            <Col span={14} className='text_title' style={{textTransform:'capitalize', fontWeight:'bold'}}>{`${ordinal_suffix_of(get_datass(rank_student, studentid, 'studentid', 'rank'))} of ${rank_student.length}`}</Col>
           </Row>:null}

           
            <Row span={24}>
            <Col span={10} className='label_title'></Col>
            <Col span={14} className='text_title' style={{textTransform:'capitalize', fontWeight:'bold'}}>{pos_messg}</Col>
           </Row>
           {/* <Row span={24}>
            <Col span={10} className='label_title'>Class Attendance</Col>
            <Col span={14} className='text_title' style={{textTransform:'capitalize', fontWeight:'bold'}}>{`${Number(attendance).toFixed(0)}% attendance, ${Number(punctuality).toFixed(0)}% punctuality`}</Col>
           </Row> */}
            </Col>
        <Col span={4} className="pull-left">
        <img 
            width="120px" 
            alt="photos"
            height="120px" 
            src={process.env.REACT_APP_SERVER_URL +"/"+ photo}
            className="img img-responsive" 
            style={{maxWidth:'120px'}} 
            onError={(e)=>{e.target.onerror=null; e.target.src= process.env.PUBLIC_URL +'/asset/icons/profile_4.png'} }
            />
    </Col>
        </Row>
        <hr/>
        <Row span={24} >  	
        <Col span={24} className='m-0 p-0'>
        <table  className="tabl" width="100%" border="3px solid #000" style={{fontFamily: 'Source Sans Pro', fontWeight:'bold'}}>
            <thead>
                <tr className="text-center justify-items-center align-items-center" style={{backgroundColor:bgc[0], color:bgc[1], fontSize:props.fontz+"px"}} >
                    <th rowSpan={1} className="text-center m-0 p-0">SN</th>
                    <th rowSpan={1} className="text-center m-0 p-0" style={{minWidth:'150px'}}>SUBJECT</th>
                    {/* {theadm} */}
                    {/* <th rowSpan={1} className="align-self-center text-center m-0 p-0">TOTAL<br/> (100%)</th>
                    <th rowSpan={1} className="align-self-center text-center m-0 p-0">GRADE<br/></th>
                    <th rowSpan={1} className="text-center m-0 p-0">AVG</th>
                    <th rowSpan={1} className="text-center m-0 p-0">MAX</th>
                    <th rowSpan={1} className="text-center m-0 p-0">MIN</th>
                    <th rowSpan={1} className="text-center m-0 p-0" style={{minWidth:'100px'}}>RANK</th> */}
                    {score_column ? theadm : null}
                    {total_column ? <th rowSpan={1} className="align-self-center text-center m-0 p-0">TOTAL<br/> (100%)</th>:null}
                    {grade_column ? <th rowSpan={1} className="align-self-center text-center m-0 p-0">GRADE<br/></th>:null}
                    {grade_inter ? <th rowSpan={1} className="align-self-center text-center m-0 p-0">INTERPRETATION<br/></th>:null}
                    {subject_average ? <th rowSpan={1} className="text-center m-0 p-0">AVG</th>:null}
                    {subject_maximum ? <th rowSpan={1} className="text-center m-0 p-0">MAX</th>:null}
                    {subject_minimum ? <th rowSpan={1} className="text-center m-0 p-0">MIN</th>:null}
                    {subject_ranking? <th rowSpan={1} className="text-center m-0 p-0">RANK</th>:null}
                </tr>
            </thead>
            <tbody style={{color:'#000'}}>
            {acct}
            </tbody>
            {/* <tfoot>
                <tr className="text-center" style={{backgroundColor:bgc[0], color:bgc[1], fontSize:props.fontz+"px"}}>
                    <th className="text-center m-0 p-0">SN</th>
                    <th className="text-center m-0 p-0">AVERAGE</th>
                    {tfootm}
                    <th className="text-center m-0 p-0">{avg(s_sum)}</th>
                    <th className="text-center m-0 p-0">{gradingf(avg(s_sum), class_grades)}<br/></th>
                    <th className="text-center m-0 p-0">{avg(s_avg)}</th>
                    <th className="text-center m-0 p-0">{max(s_max)}</th>
                    <th className="text-center m-0 p-0">{min(s_min)}</th>
                    <th className="text-center m-0 p-0" style={{fontSize:'18px'}}>{`${ordinal_suffix_of(get_datass(rank_student, studentid, 'studentid', 'rank'))}`}</th>
                </tr>
            </tfoot> */}
            { summary_row ?
                    <tfoot>
                        <tr className="text-center" style={{backgroundColor:bgc[0], color:bgc[1], fontSize:props.fontz+"px"}}>
                            <th className="text-center m-0 p-0">SN</th>
                            <th className="text-center m-0 p-0">AVERAGE</th>
                            {score_column ?  tfootm : null }
                            {total_column ? <th className="text-center m-0 p-0">{avg(s_sum)}</th>:null}
                            {grade_column ? <th className="text-center m-0 p-0">{gradingf(avg(s_sum), class_grades)}<br/></th>:null}
                            {grade_inter ? <th className="text-center m-0 p-0">{gradingf1(avg(s_sum), class_grades)}<br/></th>:null}
                            {subject_average ? <th className="text-center m-0 p-0">{avg(s_avg)}</th>:null}
                            {subject_maximum ? <th className="text-center m-0 p-0">{max(s_max)}</th>:null}
                            {subject_minimum ? <th className="text-center m-0 p-0">{min(s_min)}</th>:null}
                            {class_position ? <th className="text-center m-0 p-0" style={{fontSize:'18px'}}>{`${ordinal_suffix_of(get_datass(rank_student, studentid, 'studentid', 'rank'))}`}</th>:<th></th>}
                        </tr>
                    </tfoot>: null}
        </table>
    </Col>
</Row>
<Row span={24} className='text-center'>  	
    <Col span={24} className=' text-center'>
        <table className="table m-0 p-0" width="100%"  >
            <tr className='m-0 p-0'>
                <td className='m-0 p-0 text-center' style={{fontWeight:'bold', fontSize:'13px'}}>
                    {/* KEYS :  {keyz.join(", ")} */}
                </td>
            </tr>
        </table>
    </Col>
</Row>
        <Row span={24}>
    <Col span={24}>
        <table className="m-0"  border="solid #000 2px" style={{fontWeight:'bold', fontStyle:'italic'}} width="100%">
            {/* <tr>
                <td>Class Average</td><td className='text-center'>{Number(class_analysis['avg']).toFixed(0)}</td>
                <td>Class Maximum</td><td className='text-center'>{Number(class_analysis['max']).toFixed(0)}</td>
                <td>Class Minimum</td><td className='text-center'>{Number(class_analysis['min']).toFixed(0)}</td>
            </tr> */}
            
        </table>
    </Col>
</Row>
        <Row span={24}>
   <Card span={24}>
       <Card span={24} type="inner">
       {/* <Row span={24} >
            {Object.keys(bas).length > 0 ? 
            <Col><h5 className='traffic'>Behavior & Psychomotor <small><i>(5 Stars Maximum)</i></small></h5></Col>
            :''}
           <Col span={24} sm={24} className="">
               <div className='d-flex flex-wrap'>
                {
                    Object.keys(bas).map(ele=>{
                    return <Row  span='12'  style={{width:'250px',padding:'-3px', fontSize:'24px' }} className="m-0 p-0 d-flex flex-nowrap">
                                <Col span={6} className="m-0 p-0 align-self-center" style={{fontSize:'13px', width:'100px'}}>
                                    {bas[ele][0]}
                                </Col>
                                <Col sm={6} className="m-0 p-0" style={{fontSize:'13px', width:'100px', padding:"-3px"}}>
                                    <ReactStars                   
                                        count={ behavior !== undefined && behavior.hasOwnProperty(ele) && behavior[ele] ? behavior[ele] * 5 : 0 }
                                        classNames='m-0 p-0'
                                        style={{margin:'0px', padding:'-2px'}}
                                        size={20}
                                        isHalf={true}
                                        emptyIcon={<i className="">-</i>}
                                        halfIcon={<i className="fa fa-star-half-alt"></i>}
                                        fullIcon={<i className="fa fa-star"></i>}
                                    />
                                </Col>
                            </Row>
                    })
                }
                
                </div>
                </Col>
            </Row> */}
       </Card>
    </Card>
</Row>
<Row span={24} className="text-left">
        <Col span={24}><h5 className='traffic'>Comments</h5></Col>
        <Col span={24} className="m-0 p-1">
        <div className="row panel panel-default">
          <div className="panel-heading">
          </div>
          <div className="panel-body" style={{fontFamily:'Bubblegum sans', fontSize:fontz+'.px'}}>
              <Col style={{display:'block'}} span={24}>
                 {gradingcomment(avg(s_sum), class_grades) }
              </Col>
          </div>
        </div>
    </Col>
</Row>
{comment ?
        <>
        {/* <Container>
            <Row xs={12} className="text-left">
                <Col xs={12}><h5 className='traffic'>Comments</h5></Col>
                <Col xs={12} className="mx-2 p-2">
                <Row  style={{fontFamily:'Quicksand', fontSize:fontz+'.px'}}>
                    <Col style={{display:'block', width:"100%"}} xs={12}>
                        {gradingcomment(avg(s_sum), class_grades)}
                    </Col>
                    {
                        Array.isArray(studentcomments) ?
                        studentcomments
                        .filter(rw=>rw !== undefined && rw !== null && parseInt(rw.studentid) == parseInt(studentid) && parseInt(rw.reportid) == parseInt(reportid) )
                        .map(rw=>{
                            let gc = rw.grpcomment !== undefined && rw.grpcomment !== null && valdateJson(rw.grpcomment) ? JSON.parse(rw.grpcomment) : []
                            return <>
                            {Array.isArray(gc) ? gc.map((pr, ins)=>{
                                let text = pr.comment
                                text = text.replaceAll('{{NAME}}', firstname.toUpperCase())
                                text = text.replaceAll('{{GENDER}}', name1)
                                text = text.replaceAll('{{GENDER2}}', name2)
                                text = text.replaceAll('{{GENDER3}}', name3)
                            return <Col key={ins} style={{display:'block'}} xs={12}>
                                        <span><b>{rw.staffname}</b></span>
                                        <span>
                                            {text}
                                            <span className="pull-right"><i className="fa fa-remove"></i></span>
                                        </span>
                                    </Col>
                                }):''}
                                </>
                        }):''
                    }
                    </Row>
                    
            </Col>
        </Row>
        </Container> */}
        <Container>
            <Row  xs={12}>
            {
                Object.keys(position_cm_arr).map((prop, ins)=>{
                    let cmm = position_cm_arr[prop] || ''
                    let last_comment = cmm[cmm.length - 1]
                    let other_comment = cmm.slice(0, -1)
                    let sh_comment = other_comment.length > 0 ? true : false
                    return <Col key={ins} style={{display:'block', fontFamily:'Quicksand', fontSize:fontz+'.px'}} xs={12}>
                                <p><b>{sh_comment ? toSentenceCase(other_comment.join(" and ")) +". ": ""}
                                <i style={{fontWeight:'bolder'}}>{last_comment}</i></b></p>  
                            </Col>
                })
            }
            </Row>
        </Container>
        </>
        :null}
   
        {Array.isArray(studentcomments) &&
         studentcomments
         .filter(rw=>rw != undefined && rw != null)
         .length > 0 ?
        <Container style={{display:'block', textAlign:'left'}}>
        <Row xs={12} style={{display:'block'}}>
        <Col style={{display:'block', width:'100%'}}>
            <h5 className='traffic'>Special Comments</h5>
        </Col>
        </Row>
        <Row xs={12} style={{display:'block'}}>
            {
                Array.isArray(studentcomments) ?
                studentcomments
                .filter(rw=>rw != undefined && rw != null )
                .map(rw=>{
                    let gc = rw.comment != undefined && rw.comment != null  ? rw.comment : ''
                    return <div style={{display:'block' , width:'100%'}}>
                            
                            <div style={{display:'block' , width:'100%'}}>{gc}</div>
                            <div style={{display:'block' , width:'100%'}} ><b>{`${rw.staffname} (${rw.office})`}</b></div>
                        </div>
            }):''}
        </Row>
        </Container>: null}
        { typeof generalcomment == 'string' && generalcomment.length > 0 ? <Row>
            <Col style={{textAlign:'left'}}>{generalcomment}</Col>
        </Row>:null}
        {parent_comment ?
                <Row span={24} style={{textAlign:'left'}}>
                    <Col span={24} gutter={2} style={{display:'block'}}>
                        <strong>Parent's/Guardian's Comment</strong><br/> <hr/>
                    </Col>
                    <Col span={12} style={{display:'block'}}>
                        <strong>Parent's/Guardian's Name</strong><br/> <hr/>
                    </Col>
                    <Col span={12} style={{display:'block'}}>
                        <strong>Parent's/Guardian's Signature and Date</strong><br/> <hr/>
                    </Col>
                 </Row>
        :null}
        <Row span={24} style={{textAlign:'left'}}>
        <Col span={24}>
        {report.files !== undefined && report.files.length > 0 ?
        <img 
            src={process.env.REACT_APP_SERVER_URL + report.files} 
            className="m-0 p-0" 
            width='170px'
            height='140px'
            alt='edit' 
            onError={(e)=>{
                e.target.onerror=null; 
                e.target.src=process.env.PUBLIC_URL+ '/icons/files.png'} }
        />:''}
        </Col>
        <Col span={24}>
        <b>__________________________</b><br/>
        <strong>{staffname} ({phone1})</strong><br/>
                {officename}
        </Col>
    </Row>
    </Col>
    </div>
</div>
</div>
</>
    )
}

const mapStateToProps = (state) => ({
    user : state.userReducer.user,
    school:state.schoolReducer.school
})

const mapDispatchToProps = {
    
}

export default connect(mapStateToProps, mapDispatchToProps)(Page)
